import React from "react";
import { Box } from "@mui/material";
import streamPreviewStyles from "./stream-preview.styles";
import { StreamNodeData } from "../nodes/stream-node";
import { EyeIcon } from "src/generic/icon/customIcons";
import streamDataLoader from "./stream-data-loader";
import metaobjectConverter from "core/services/metaStoreService/metaobject-converter";
import { useAppDispatch } from "src/stores/redux/hooks";
import {
    setStreamPreviewVisibleAction,
    closeAllSidebarsAction
} from "src/stores/redux/features/flowdesigner/flowdesigner.slice";

interface StreamPreviewProps {
    nodeId: string;
    data: StreamNodeData;
}

const StreamPreview: React.FC<StreamPreviewProps> = ({ nodeId, data }) => {
    const dispatch = useAppDispatch();

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        const streamShortName = metaobjectConverter.convertFullNameToShortName(data.metaObject.id);
        streamDataLoader.previewSourceName = metaobjectConverter.getName(data.metaObject.id);
        streamDataLoader.setStreamName(streamShortName);
        streamDataLoader.start();
        dispatch(closeAllSidebarsAction());
        dispatch(setStreamPreviewVisibleAction(true));
    };

    return (
        <>
            <Box sx={streamPreviewStyles.container} onClick={handleClick} data-test-id="stream-preview-button">
                <EyeIcon />
            </Box>
        </>
    );
};

export default StreamPreview;
